/**
 * Width of a structure row's leading column, which holds the colour dot or
 * the selection checkbox: the width of the search field's icon above it.
 */
export const LEADING_COLUMN_PX = 18;
